<script setup lang="ts">
import { t } from '@fondof-ui/lib/translations'

import { FondofIcon } from '@fond-of/fondof-icons'

const currentYear = new Date().getFullYear()
</script>
<template>
  <div
    class="row-start-1 row-end-3 grid h-full w-full grid-cols-subgrid grid-rows-subgrid md:col-start-[first-col] md:row-start-[first-row] md:row-end-[third-row]"
  >
    <div class="row-start-1 mb-10 md:row-start-[first-row] md:mb-0">
      <h4 class="headline-style mb-5 w-full text-base">
        {{ t('footer.aBrandOf') }}
      </h4>
      <FondofIcon class="size-17.5" />
    </div>
    <div
      class="mb-17.5 row-start-2 inline-flex items-center text-sm md:row-start-[second-row] md:mb-0"
    >
      &copy; {{ currentYear }} FOND OF GmbH
    </div>
  </div>
</template>
